'use client';

import { FC, useState, useId } from 'react';
import { PasswordProps } from './Password.types';
import { Flex, Text, Input } from '@/_components';
import styles from './Password.module.css';
import { checkPasswordForError } from '@/_utils/passwords';
import { getClasses } from '@/_utils/classnames';

export const Password: FC<PasswordProps> = ({
  confirmPassword,
  isLabelHidden,
  label,
  onChange,
  isDisabled,
  placeholder,
  showIndicator,
  value,
}) => {
  const id = useId();

  const [isPristine, setIsPristine] = useState<boolean>(true);
  const { strength, error } = checkPasswordForError(value, confirmPassword);

  const onFocus = () => setIsPristine(false);

  const shouldShowIndicator: boolean = Boolean(
    !!value && !isPristine && showIndicator,
  );
  const passwordIndicatorScoreClasses: string = getClasses(
    styles.password__indicator,
    {
      [styles.password__indicatorStrength4]: strength === 4,
      [styles.password__indicatorStrength3]: strength === 3,
      [styles.password__indicatorStrength2]: strength === 2,
      [styles.password__indicatorStrength1]: strength < 2,
      [styles.password__indicatorVisible]: shouldShowIndicator,
    },
  );

  return (
    <Flex isColumn={true} gap={2}>
      <Input
        label={label}
        name="password"
        value={value}
        id={id}
        placeholder={placeholder}
        isLabelHidden={isLabelHidden}
        isDisabled={isDisabled}
        onFocus={onFocus}
        autoComplete="new-password"
        iconRight="eye"
        type="password"
        onChange={onChange}
      />
      <Flex isColumn={true} gap={4} className={passwordIndicatorScoreClasses}>
        <div className={styles.password__indicator__bars}>
          <span />
          <span />
          <span />
          <span />
        </div>
        {!!error && (
          <Text type="tiny" color="currentcolor">
            {error}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
